<template>
	<div class="page" v-loading="loadingPage" element-loading-text="加载中……">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<router-link to="/crm/customer/add">
				<el-button type="success" round size="small">
					<span class="el-icon-plus"></span>
					添加客户
				</el-button>
			</router-link>
		</div>
		<div class="page-main">
			<el-row :gutter="20">
				<el-col :span="18">
					<el-card class="box-card" :body-style="{ padding: 0 }">
						<div slot="header" class="clearfix">
							<div class="flex justify-between align-center">
								<div class="flex align-center">
									<span class="el-icon-connection"></span>
									<span class="text-bold margin-left-sm">业务往来</span>
								</div>
								<div class="flex align-center"></div>
							</div>
						</div>
						<div class="data-box flex align-center justify-center flex-wrap padding-sm">
							<div class="item bg-olive margin-sm">
								<div class="label"><span>联系人</span></div>
								<div class="icon"><i class="el-icon-s-custom"></i></div>
								<div class="text"><span class="text-sl text-bold">2</span></div>
							</div>
							<div class="item bg-purple margin-sm">
								<div class="label"><span>合同</span></div>
								<div class="icon"><i class="el-icon-s-check"></i></div>
								<div class="text"><span class="text-sl text-bold">2</span></div>
							</div>
							<div class="item bg-blue margin-sm">
								<div class="label"><span>订单</span></div>
								<div class="icon"><i class="el-icon-s-order"></i></div>
								<div class="text"><span class="text-sl text-bold">2</span></div>
							</div>
							<div class="item bg-orange margin-sm">
								<div class="label"><span>服务</span></div>
								<div class="icon"><i class="el-icon-discount"></i></div>
								<div class="text"><span class="text-sl text-bold">1</span></div>
							</div>
							<div class="item bg-cyan margin-sm">
								<div class="label"><span>工单</span></div>
								<div class="icon"><i class="el-icon-set-up"></i></div>
								<div class="text"><span class="text-sl text-bold">4</span></div>
							</div>
							<div class="item bg-mauve margin-sm">
								<div class="label"><span>应收</span></div>
								<div class="icon"><i class="el-icon-postcard"></i></div>
								<div class="text"><span class="text-xl" v-format="'#,##0.00'">1415700</span></div>
							</div>
							<div class="item bg-red margin-sm">
								<div class="label"><span>收款</span></div>
								<div class="icon"><i class="el-icon-money"></i></div>
								<div class="text"><span class="text-xl" v-format="'#,##0.00'">1352650</span></div>
							</div>
						</div>
					</el-card>
					<el-card class="box-card margin-top" :body-style="{ padding: 0 }">
						<div slot="header" class="flex justify-between align-center">
							<div class="flex align-center">
								<span class="el-icon-document"></span>
								<span class="text-bold margin-left-sm">基础资料</span>
							</div>
							<el-button type="warning" size="small" @click="showModifyDialog">
								<i class="el-icon-edit"></i>
								<span>修改</span>
							</el-button>
						</div>
						<div class="padding padding-top-xl">
							<el-row :gutter="20">
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">客户名称</div>
										<div class="con">
											<span>{{ customerInfo.name }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">统一社会信用代码</div>
										<div class="con">
											<span>{{ customerInfo.credit_code }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">类型</div>
										<div class="con">
											<span class="cu-tag line-blue radius" v-if="customerInfo.subject_type == '1'">公司</span>
											<span class="cu-tag line-purple radius" v-else-if="customerInfo.subject_type == '2'">个体</span>
											<span class="cu-tag line-grey radius" v-else>其他</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">主要联系人</div>
										<div class="con">
											<div class="" v-if="customerInfo.contacter">
												<span class="text-bold">{{ customerInfo.contacter.name }}</span>
												<span class="text-grey" v-if="customerInfo.contacter.mobile">（{{ customerInfo.contacter.mobile }}）</span>
											</div>
										</div>
									</div>
								</el-col>
								<el-col :span="24">
									<div class="infoshow">
										<div class="title">行业</div>
										<div class="con">
											<el-tag
												class="margin-right-sm"
												type="info"
												size="small"
												v-for="(item, index) in customerInfo.industryData"
												v-if="customerInfo.industryData"
												:key="index"
											>
												{{ item.name }}
											</el-tag>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">固定电话</div>
										<div class="con">
											<span class="">{{ customerInfo.telephone }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">传真</div>
										<div class="con">
											<span class="">{{ customerInfo.fax }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">所属地区</div>
										<div class="con">
											<el-breadcrumb separator="-">
												<el-breadcrumb-item v-if="customerInfo.province">{{ customerInfo.province.name }}</el-breadcrumb-item>
												<el-breadcrumb-item v-if="customerInfo.city">{{ customerInfo.city.name }}</el-breadcrumb-item>
												<el-breadcrumb-item v-if="customerInfo.district">{{ customerInfo.district.name }}</el-breadcrumb-item>
											</el-breadcrumb>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">详细地址</div>
										<div class="con">
											<span class="">{{ customerInfo.address }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">业务人员</div>
										<div class="con">
											<popover-user-card
												:userId="customerInfo.salesman_id"
												:text="customerInfo.salesman.name"
												:config="{ placement: 'right' }"
												v-if="customerInfo.salesman"
											></popover-user-card>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">客服人员</div>
										<div class="con">
											<popover-user-card
												:userId="customerInfo.service_id"
												:text="customerInfo.service.name"
												:config="{ placement: 'right' }"
												v-if="customerInfo.service"
											></popover-user-card>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">客户来源</div>
										<div class="con"></div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">添加者</div>
										<div class="con">
											<popover-user-card
												:userId="customerInfo.adduser_id"
												:text="customerInfo.adduser.name"
												:config="{ placement: 'right' }"
												v-if="customerInfo.adduser"
											></popover-user-card>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">创建时间</div>
										<div class="con">
											<span class="">{{ customerInfo.addtime }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">最后更新</div>
										<div class="con">
											<span class="">{{ customerInfo.updatetime }}</span>
										</div>
									</div>
								</el-col>
							</el-row>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6">
					<el-card class="box-card" :body-style="{ padding: 0 }">
						<div slot="header" class="clearfix">
							<div class="flex justify-between align-center">
								<div class="flex align-center">
									<span class="el-icon-connection"></span>
									<span class="text-bold margin-left-sm">日志/动态</span>
								</div>
							</div>
						</div>
						<div class="margin-tb padding-tb-xs padding-right margin-right-xs" style="height: 943px; overflow-y: auto;" v-loading="loadingLog">
							<el-timeline v-if="logList.infos.length > 0">
								<el-timeline-item hide-timestamp placement="top" v-for="item in logList.infos" :key="item.id">
									<el-card>
										<div class="padding-bottom ">{{ item.content }}</div>
										<div class="flex align-center justify-between">
											<div>
												<i class="el-icon-user margin-right-xs"></i>
												<popover-user-card
													:userId="item.user.user_id"
													:text="item.user.name"
													:config="{ placement: 'right' }"
													v-if="item.user"
												></popover-user-card>
												<span class="text-grey" v-else>客户</span>
											</div>
											<div>
												<i class="el-icon-time margin-right-xs"></i>
												<span class="text-grey">{{ item.time }}</span>
											</div>
										</div>
									</el-card>
								</el-timeline-item>
							</el-timeline>
							<div class="text-center padding-sm" v-if="loadingLog">
								<i class="el-icon-refresh"></i>
								<span class="margin-left-xs">加载中……</span>
							</div>
							<div class="text-center" v-if="logList.total / logList.size > logList.page && !loadingLog">
								<el-button type="infor" @click="getLogList">
									<i class="el-icon-refresh"></i>
									<span class="margin-left-xs">加载更多</span>
								</el-button>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>

			<!-- 修改客户信息 -->
			<el-dialog title="修改客户信息" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisibleModify" top="5vh">
				<div style="height: 70vh; overflow: auto;" class="padding-lr margin-top" v-loading="loadingModify">
					<el-form ref="formModify" :model="formModify" label-width="180px" label-suffix=":">
						<el-form-item label="名称" prop="name" :rules="{ required: true, message: '请输入客户名称', trigger: 'blur' }">
							<el-input v-model="formModify.name" placeholder="客户名称,一般是企业名称" autocomplete="off" style="width: 300px;"></el-input>
						</el-form-item>
						<el-form-item label="统一社会信用代码" prop="credit_code" :rules="{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }">
							<span v-if="formModify.credit_code">{{ formModify.credit_code }}</span>
							<el-input v-model="formModify.credit_code" placeholder="统一社会信用代码" autocomplete="off" style="width: 300px;" v-else></el-input>
						</el-form-item>
						<el-form-item label="类型" prop="subject_type" :rules="{ required: true, message: '请选择类型', trigger: 'blur' }">
							<el-radio-group v-model="formModify.subject_type">
								<el-radio :label="1">公司</el-radio>
								<el-radio :label="2">个体</el-radio>
								<el-radio :label="0">其他</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="联系人" prop="contacter" :rules="{ required: true, message: '请选择联系人', trigger: 'blur' }">
							<div class="flex align-center">
								<div class="" v-if="formModify.contacter">
									<span class="text-bold">{{ formModify.contacter.name }}</span>
									<span class="text-grey" v-if="formModify.contacter.mobile">({{ formModify.contacter.mobile }} )</span>
								</div>
								<el-button size="small" type="primary" plain round class="margin-left" @click="dialogVisibleCheckContacter = true">
									<span class="iconfont-genghuan"></span>
									更换
								</el-button>
							</div>
							<check-contacter
								:show="dialogVisibleCheckContacter"
								:customer="formModify"
								:current="formModify.contacter"
								@close="dialogVisibleCheckContacter = false"
								@check="changeContacter"
							></check-contacter>
						</el-form-item>
						<el-form-item label="行业" prop="industry" :rules="{ required: true, message: '请选择所属行业', trigger: 'blur' }">
							<select-industry :selected="formModify.industry" :clearable="true" :multiple="true" @change="changeIndustry"></select-industry>
							<i class="margin-left-xs text-grey el-icon-info"></i>
							<span class="text-grey">可多选</span>
						</el-form-item>
						<el-form-item label="固定电话" prop="telephone">
							<el-input v-model="formModify.telephone" placeholder="固定电话" autocomplete="off" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="传真" prop="fax">
							<el-input v-model="formModify.fax" placeholder="传真" autocomplete="off" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="所属地区" prop="region" :rules="{ required: true, message: '请选择所属省市县(区)', trigger: 'blur' }">
							<cascader-region :value="formModify.region" autoLoad :deep="3" @change="changeRegion"></cascader-region>
						</el-form-item>
						<el-form-item label="地址" prop="address" :rules="{ required: true, message: '请输入地址', trigger: 'blur' }">
							<el-input v-model="formModify.address" placeholder="详细地址" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="备注" prop="remark">
							<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="备注信息" v-model="formModify.remark"></el-input>
						</el-form-item>
						<el-form-item label="业务人员" prop="salesman_id">
							<el-tag
								size="small"
								type="info"
								disable-transitions
								:closable="formModify.salesman ? true : false"
								@close="clearEmployee('salesman')"
								@click="check_employee_show('salesman')"
								v-if="formModify.salesman"
							>
								<span>{{ formModify.salesman.name }}({{ formModify.salesman.officeid }})</span>
							</el-tag>
							<el-button size="medium" @click="check_employee_show('salesman')" v-else>
								点击选择
								<i class="el-icon-arrow-down"></i>
							</el-button>
						</el-form-item>
						<el-form-item label="客服人员" prop="service_id">
							<el-tag
								size="small"
								type="info"
								disable-transitions
								:closable="formModify.service ? true : false"
								@close="clearEmployee('service')"
								@click="check_employee_show('service')"
								v-if="formModify.service"
							>
								<span>{{ formModify.service.name }}({{ formModify.service.officeid }})</span>
							</el-tag>
							<el-button size="medium" @click="check_employee_show('service')" v-else>
								点击选择
								<i class="el-icon-arrow-down"></i>
							</el-button>
						</el-form-item>
						<el-form-item label="" class="border-top margin-top padding-top">
							<el-button type="primary" @click="formSubmitModify">确 定</el-button>
							<el-button @click="dialogVisibleModify = false">取 消</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-dialog>
		</div>
		<check-employee :show="checkEmployeeShow" :dKey="checkEmployeeKey" @close="checkEmployeeClose" @change="changeEmployee" type="single"></check-employee>
	</div>
</template>

<script>
import popoverUserCard from '@/components/popover-user-card.vue';
import checkContacter from '@/components/check-contacter.vue';
import selectIndustry from '@/components/select-industry.vue';
import cascaderRegion from '@/components/cascader-region.vue';
import checkEmployee from '@/components/check-employee.vue';

export default {
	components: { popoverUserCard, checkContacter, selectIndustry, cascaderRegion, checkEmployee },
	data() {
		return {
			loadingPage: false,
			id: '',
			customerInfo: {},
			logList: {
				errmsg: '',
				page: 0,
				size: 10,
				total: 0,
				infos: []
			},
			loadingLog: false,
			previewList: [],
			formDeal: {},
			dialogVisibleModify: false,
			loadingModify: false,
			formModify: {},
			pageData: {},
			dialogVisibleCheckContacter: false,
			checkEmployeeShow: false,
			checkEmployeeCurrent: [],
			checkEmployeeKey: null,
			checkEmployeeType: 'single',
			salesman: null,
			service: null
		};
	},
	beforecreate: function() {},
	created: function() {
		if (this.$route.params.id) {
			this.id = this.$route.params.id;
			this.getInfo();
		} else {
			this.$alert('页面参数错误！', {
				title: '操作错误',
				type: 'error',
				callback: r => {
					this.$router.back(-1);
				}
			});
			return false;
		}
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		getInfo() {
			this.loadingPage = true;
			this.$http.post('/server/index.php?m=crm/customer&a=getCustomerInfo', { id: this.id }).then(
				res => {
					this.loadingPage = false;
					if (res.result == 'ok') {
						this.customerInfo = res.data;
						this.getLogList(true);
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loadingPage = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		getLogList() {
			if (arguments[0] === true) {
				this.logList.page = 0;
				this.logList.infos = [];
			}
			if (this.logList.page > 0 && this.logList.page >= Math.ceil(this.logList.total / this.logList.size)) {
				return false;
			}
			this.loadingLog = true;
			this.$http.post('/server/index.php?m=crm/customer&a=getLogList', { id: this.id, page: this.logList.page + 1, size: this.logList.size }).then(
				res => {
					this.loadingLog = false;
					if (res.result == 'ok') {
						this.logList.errmsg = '';
						if (this.logList.infos.length == 0) {
							this.logList = res.data;
						} else {
							this.logList.page = res.data.page;
							for (let i = 0; i < res.data.infos.length; i++) {
								this.logList.infos.push(res.data.infos[i]);
							}
						}
					} else {
						this.logList.errmsg = res.msg;
					}
				},
				r => {
					this.loadingLog = false;
					this.logList.errmsg = '网络错误，指定的服务无法访问。';
				}
			);
		},
		showModifyDialog() {
			if (this.customerInfo.subject_state == 0) {
				this.$alert('该客户尚未完成工商登记，暂无法修改信息。', '无法修改', {
					type: 'warning'
				});
				return false;
			}
			this.formModify = Object.assign({}, this.customerInfo);
			this.dialogVisibleModify = true;
		},
		changeIndustry(data) {
			console.log(data);
			this.formModify.industry = data;
		},
		changeRegion(data) {
			console.log(data);
		},
		changeContacter(data) {
			this.formModify.contacter = data;
			this.formModify.contacter_id = data.id;
		},
		check_employee_show(key) {
			this.checkEmployeeShow = true;
			this.checkEmployeeKey = key;
		},
		checkEmployeeClose() {
			this.checkEmployeeShow = false;
		},
		changeEmployee(e) {
			this.formModify[e.key] = e.data;
		},
		clearEmployee(key) {
			this.formModify[key] = null;
		},
		formSubmitModify() {
			this.$refs['formModify'].validate(valid => {
				if (valid) {
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=crm/customer&a=modify', { data: this.formModify }).then(
						res => {
							loading.close();
							if (typeof res.data != 'object') {
								this.$alert(res.data ? res.data : '(无返回数据)', {
									title: '返回数据格式错误',
									type: 'error'
								});
							} else {
								if (res.data.result == 'ok') {
									this.$message({
										message: '修改客户信息成功',
										type: 'success'
									});
									this.dialogVisibleModify = false;
									this.getInfo();
								} else {
									this.$alert(res.data.msg, {
										title: '操作错误',
										type: 'error'
									});
								}
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
					return false;
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	}
};
</script>

<style>
.el-card__header {
	padding: 0 20px;
	height: 60px;
	line-height: 60px;
}
.infoshow .title {
	min-width: 180px;
}
.data-box {
	position: relative;
}
.data-box .item {
	box-sizing: content-box;
	padding: 20px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 115px;
	height: 120px;
}
.data-box .item .label {
	position: absolute;
	top: 1px;
	left: 1px;
	padding: 2px 6px;
	font-size: 12px;
	background: #fff;
	color: var(--darkGray);
	font-weight: bold;
}
.data-box .item .icon {
	font-size: 64px;
}
.data-box .item .text {
	height: 40px;
	line-height: 40px;
}
</style>
